<template>
<div class="indexContainer" :style="{ paddingLeft : menuCollapse ? '76px' : '230px' }">
  <div class="leftAside" :style="{ width : menuCollapse ? '76px' : '230px' }">
    <left-asides></left-asides>
  </div>
  <div class="mainWrap">
    <div class="topWrap">
      <top-aside></top-aside>
    </div>
    <div class="mainContentAll">
      <router-view ></router-view>
    </div>
  </div>
  <!-- <div class="mainContainer">
    <div class="topSide">
      <top-aside @indent="indent"></top-aside>
    </div>
    <div class="mainContents" :style="styleObject">
      <div :class="['leftSide',isCollapse ? 'leftSideNavSmall' : '']">
        <left-asides :collapse="isCollapse"></left-asides>
      </div>
      <div :class="['findexMainContent',isCollapse ? 'findexMainContentWeight' : '']">
        <div class="tavBox">
          <ment-tag></ment-tag>
        </div>
        <div class="contentShowBox">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div> -->
  <div style="display:none;">
    <baidu-map class="map" :center="{
        lng: '116.404',
        lat: '39.915'
      }" :zoom="14" @ready="mapReady">
      <!-- 地图容器 -->
      <bm-view :style="{width:'100%',height: '100%'}"></bm-view>
    </baidu-map> 
  </div>

  <!-- 报警弹框 --><!--  animate__shakeX animate__bounceInRight -->
  <ul class="alarm-list" v-show="isAlarmShow">
    <li class="alarm-item" v-for="(item, i) in alarmList" :key="item.alarmId" @click="handleShowBox(item)">
      <div class="item">
        <h4>
          <span>报警通知</span>
          <i class="close el-icon-close" @click.stop="handleCloseAlarm(i)"></i>
        </h4>
        <p>
          <span>报警内容: </span><span>{{item.content}}</span>
        </p>
        <p>
          <!-- <span>报警位置: </span><span>{{item.installLocation}}</span> -->
          <span>区域: </span><span>{{item.regionName}}</span>
        </p>
      </div>
    </li>
  </ul>

  <!-- 强制修改密码 -->
  <el-dialog class="editPwdDialog" title="修改密码" :visible.sync="editPwdDialog" center :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false" width="600px"><!--  @closed="editPwdDialogClose" -->
    <h3 class="editPwdDialogTitle"><i class="el-icon-warning-outline"></i>尊敬的用户，为了加强对数据安全的保护，需定期对密码进行修改，请修改密码，新密码要求包含【1.密码必须包含大小写字母、数字、特殊字符(!@#$%^&+=_)且密码不少于八位；2.密码不能含有相同字符（例如111、aaa）连续3位或3位以上；3.密码禁止设置递增的字母或数字（例如abc,123）连续3位或3位以上!；4.密码不能含有标准键相邻按键组合（例如ASDFG,QWERTY）】，由此给您带来不便，敬请谅解！</h3>
    <div class="tenantInfoForm">
      <el-form :model="editPwdform" class="editPwdform" ref="editPwdform" :rules="editPwdformRules">
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="editPwdform.newPassword" placeholder="请输入新密码" type="password" show-password></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="newPasswordConfirm">
          <el-input v-model="editPwdform.newPasswordConfirm" placeholder="请再次输入新密码" type="password" show-password></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button class="editPwdRequire" @click="editPwdConfirm" icon="el-icon-lock">修改密码</el-button>
    </div>
  </el-dialog>
  <!-- 强制修改密码 end -->
</div>
</template>

<script>
import TopAside from "@/components/layout/TopAside";
import LeftAsides from "@/components/layout/LeftAsides";
import MentTag from "@/components/layout/MentTag";
import wsMixin from '@/mixins/ws.js'
import setPwd from '@/mixins/setPwd.js'
export default {
  components: {
    TopAside,
    LeftAsides,
    MentTag,
  },
  mixins: [wsMixin, setPwd],
  data() {
    return {
      styleObject: {
        height: ""
      },
      isCollapse: false,
    };
  },
  mounted() {
  },
  created() {
    
    this.isAlarmShow = true
    this.makeheight();
    this.bodyWidthInit()
  },
  computed:{
    menuCollapse(){
      return this.$store.state.menuIsCollapse
    },
    screenSize(){
      return this.$store.state.screen
    },
  },
  watch:{
    screenSize(){
      this.makeheight();
      this.bodyWidthInit()
    }
  },
  methods: {
    mapReady({
      BMap,
      map
    }) {
      window.baiduMap = BMap
      window.map = map
    },
    //动态获取中间滚动高度,'height'为头部和尾部的高度之和
    makeheight(height = 74) {
      let _this = this;
      _this.styleObject.height = window.innerHeight - height + "px";
      window.onresize = () => {
        return (() => {
          _this.styleObject.height = window.innerHeight - height + "px";
        })();
      };
    },
    indent(data) {
      // console.log(data)
      this.isCollapse = data
    },
    bodyWidthInit(){
      let bodyWidth = document.body.clientWidth
      this.bodyWidth = bodyWidth
      if(bodyWidth < 1350){
        this.$store.commit('changeMenuCollapse',true)
      } else {
        this.$store.commit('changeMenuCollapse',false)
      }
    },
    /**
     * @Description 打开某个报警弹窗
     * @Author      YOYO     -             2021-11-25
     */
    handleShowBox (item) {
      console.log(item)
      this.$router.push({ name: 'alarmHistory' })
    },
    /**
     * @Description 关闭某个报警弹窗
     * @Author      YOYO     -             2021-11-25
     */
    handleCloseAlarm (i) {
      let alarmList = [ ...this.alarmList ]
      alarmList.splice(i, 1)
      this.alarmList = alarmList
      // sessionStorage.setItem('alarmList', JSON.stringify(alarmList))
      this.resetSetItem('alarmList', JSON.stringify(alarmList), 7)
      window.speechSynthesis.cancel()
      this.audioDemo && this.audioDemo.pause()
    },
    getStaticData () {
      console.log('测试')
    }
  }
};
</script>

<style lang="scss" scoped>
.indexContainer {
  height: 100%;
  position: relative;
  transition: padding 0.3s;
  .leftAside{
    position: absolute;
    height: 100%;
    top: 0;
    left: 0;
    background: linear-gradient(to bottom, #192F78, #111835);
    // background: #33383E;
    transition: width 0.3s;
  }
  .mainWrap{
    height: 100%;
    position: relative;
    padding: 74px 0 0;
    box-sizing: border-box;
    background: #F2F8FC;
    .topWrap{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 74px;
      // background: #fff;
      // box-shadow: 0px 1px 0px 0px rgba(227, 227, 227, 0.5);
      // border-bottom: 1px solid rgba(227, 227, 227, 0.5);
    }
    .mainContentAll{
      height: 100%;
      box-sizing: border-box;
    }
  }
  .alarm-list {
    position: absolute;
    bottom: 10px;
    right: 30px;
    z-index: 999;
    width: 265px;
    max-height: 80%;
    overflow-y: auto;
    overflow-x: hidden;
    transition: opacity .3s,transform .3s,left .3s,right .3s,top .4s,bottom .3s;

    .alarm-item {
      width: 260px;
      min-height: 120px;
      color: #fff;
      background-size: 100% 100%;
      cursor: pointer;
      transition: .8s;
      box-shadow: 0 0 2px 2px rgba(242, 242, 242, 1);
      border: 1px solid #EBEEF5;
      background-color: #fff;
      border-radius: 8px;
      box-sizing: border-box;
      margin: 10px auto;
      .item {
        // padding: 10px 15px 25px;
        color: #FC2121;
        h4 {
          height: 28px;
          line-height: 28px;
          font-size: 14px;
          // background-image: linear-gradient(to right, rgba(222, 2, 41, 0.2), rgba(222, 2, 41, 0));
          margin-top: 15px;
          font-weight: bold;
          >span {
            margin-left: 10px;
          }
          .close {
            float: right;
            // border: 1px solid rgba(252, 33, 33, .6);
            width: 16px;
            height: 16px;
            line-height: 16px;
            text-align: center;
            margin-right: 10px;
            margin-top: 5px;
            color: #909399;
          }
        }
        p {
          margin: 10px 15px;
          font-size: 12px;
          span {
            &:first-child {
              display: inline-block;
              padding-right: 10px;
              color: #000;
            }
            &:last-child {
              color: #909399;
              word-wrap: break-word;
            }
          }
        }
      }
    }
    &::-webkit-scrollbar {
      width: 0px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0);
      background: rgba(2,217,253,0.5);
    }
    &::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,1);
      border-radius: 0;
      background: rgba(0,0,0,0.5);
    }
  }
  .editPwdDialogTitle {
    font-size: 14px;
    color: red;
    vertical-align: middle;
    i {
      font-size: 18px;
      margin-right: 5px;
      vertical-align: middle;
    }
  }
}
</style>
